import { sendErrorEvent } from '@Analytics';
import { FeedbackSignal } from '@Models';
import { bopsApi } from '@Network';

export const COPY_DEBOUNCE_MS = 5_000;

// Module scope is fine: this is a debounce clock, not state anything renders.
const lastCopyAt = new Map<string, number>();

export const resetSignalDebounceForTests = (): void => lastCopyAt.clear();

/** Fire-and-forget: a signal is analytics, so a failure must never reach the user. */
export const sendSignal = (conversationId: string, timestamp: string, signal: FeedbackSignal): void => {
  if (!conversationId || !timestamp) return;

  if (signal === FeedbackSignal.COPY) {
    const key = `${conversationId}#${timestamp}`;
    const now = Date.now();
    const last = lastCopyAt.get(key);
    if (last !== undefined && now - last < COPY_DEBOUNCE_MS) return;
    lastCopyAt.set(key, now);
  }

  bopsApi.updateInteractionFeedback(conversationId, { timestamp, signal }).catch((error: unknown) => {
    const message = error instanceof Error ? error.message : String(error);
    sendErrorEvent(`Failed to send ${signal} signal for conversation ${conversationId}. Error: ${message}`);
  });
};
